import React from "react";
import styles from "./CustomInput.module.css";

interface CustomInputProps {
  label: string;
  type: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  placeholder?: string;
  min?: number; 
  id?: string
}

const CustomInput: React.FC<CustomInputProps> = ({
  label,
  type,
  name,
  value,
  onChange,
  required = false,
  placeholder = "",
}) => {
  return (
    <div className={styles.formGroup}>
      <label className={styles.formLabel}>
        {label} {required && "*"}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={styles.formInput}
      />
    </div>
  );
};

export default CustomInput;
